import {Injectable} from '@angular/core';
import {PrePaiement} from './../models/pre-paiement.model'
import {NoShow} from './../models/no-show.model'
import {Annulation} from './../models/annulation.model'
import {DetailAnnulation} from './../models/detail-annulation.model'
import * as moment from 'moment';
import {TranslateService} from '@ngx-translate/core';
import {WindowRefService} from '@app/core/window-ref.service';

@Injectable({
    providedIn: 'root'
})
export class BookingPolicyService {
    static readonly _CrMinType_Fixe: number = 1;
    static readonly _CrMinType_PercenteOfFirstNight: number = 2;
    static readonly _CrMinType_Nuit: number = 3;

    static readonly _NoRemborsable: number = 9;
    static readonly _FreeCancelation: number = 10;
    static readonly _Flexible: number = 11;
    static readonly _NoRemborsableNoDetected: number = 12;

    constructor(public translate: TranslateService, private winRef: WindowRefService) {}


    /**
     * Get PrePaiement Traduciton
     */
    getPrePaiement(PrePaiement: PrePaiement) {
        if (!PrePaiement.hasPr || PrePaiement.nbr == 0) {
            return {codemot: 'static.lhotelnexigepasdeprepaiement', params: {}}
        }
        else {
            if (PrePaiement.type) {
                return {codemot: 'static.lhotelexigeunprepaiementde$x1%dumontanttotaldela1erenuit', params: {'val1': PrePaiement.nbr}} /* Code Mot edprecated To Change */
            } else {
                return {codemot: 'static.lhotelexigeunprepaiementde$x1%dumontanttotaldelareservation', params: {'val1': PrePaiement.nbr}} /* Code Mot edprecated To Change */
            }
        }
    }
    /**
     * Get NoShown Traduciton
     */
    getNoShow(noShow: NoShow) {
        if (!noShow.hasNs || noShow.nbr == 0) {
            return {codemot: 'static.pasdefraisencasdenoshow', params: {}}
        } else {
            if (noShow.isFierstNight()) {
                return {codemot: 'static.incaseofnoshow,thehotelrequires$x1percentofthetotalamountofthefirstnight', params: {'val1': noShow.nbr}}
            } else {
                return {codemot: 'static.incaseofnoshow,thehotelrequires$x1percentofthetotalamountofthebooking', params: {'val1': noShow.nbr}}
            }

        }
    }

    getNoRemboursable(annulation: Annulation) {
        let NoRemboursable = {tradcution: null, exeption: null};
        NoRemboursable.tradcution = {codemot: 'static.incaseofcancellation,thehotelwillcharge$x1%ofthetotalamountofthebooking', params: {'val1': 100}}
        if (annulation.crHeurAnnulation > 0) {
            NoRemboursable.exeption = {codemot: 'static.annulationgratuite$x1heuresapresladatedereservation', params: {'val1': annulation.crHeurAnnulation}}
        }
        return NoRemboursable;
    }
    getAnnulationGratuit() {
        let annulationgratuit = {tradcution: null, exeption: null};
        annulationgratuit.tradcution = {codemot: 'static.annulationgratuite', params: {}}
        return annulationgratuit;
    }

    getFelexible(data: DetailAnnulation, isHeur: any, start, time): any {
        // Supprimer le décalage horaire de la chaîne
        let startSansDecalage = start.toString().replace(/GMT[^\)]*\)/, '').trim();
        
        let hm = time.split(':'), hours = parseInt(hm[0]), minutes;
        minutes = hm.length > 1 ? hm[1] : 0;
        
        // Étape 1 : Extraire le décalage horaire
        let match = start.toString().match(/GMT([+-]\d{2})(\d{2})/);
        let decalageHeures = 0;

        if (match) {
            let heures = parseInt(match[1]);
            let minutesDecalage = parseInt(match[2]);
            decalageHeures = heures + minutesDecalage / 60;
        }
        hours += decalageHeures;

        let today = moment()/*.set({hour: hours, minute: minutes})*/.format('YYYY-MM-DD');
        let units: moment.unitOfTime.DurationConstructor = isHeur;
        let lastto = moment(startSansDecalage).set({hour: hours, minute: minutes}).subtract(data.to, units).utc().format('YYYY-MM-DD HH:mm:ss');
        let from = moment(startSansDecalage).set({hour: hours, minute: minutes}).subtract(data.from, units).utc().format('YYYY-MM-DD HH:mm:ss');
        //        if (from < today)
        //            from = today;
        if (data.from === 0) {
            //            if (lastto <= today) {
            //                lastto = moment().set({hour: 0/*hours*/, minute: 0/*minutes*/}).format('YYYY-MM-DD HH');
            //            }
            return {type: 0, from: null, to: moment(lastto), units: units};
        }
        if (data.from != 0 && data.to > 0) {

            //            if (lastto <= today) {
            //                if (from == today) {
            //                    return false;
            //                }
            //                console.log({type: 1, from: moment(from), to: moment(today), lastto:    lastto});
            //                return {type: 1, from: moment(from), to: moment(today)};
            //            } else {
            //                if (from >= today) {
            return {type: 1, from: moment(from), to: moment(lastto), units: units};
            //                }
            //            }
            //            return false;
        }

        if (data.to < 0 || data.to == null) {
            //            if (moment(from).format('YYYY-MM-DD') < today) { // TODO : test par heure =>  if (from <= today)
            //                return {type: 3, from: moment(from), to: null, last: data.from, isHeur : isHeur};
            //            }
            return {type: 2, from: moment(from), to: null, units: units};
        }
    }

    getFlexibleTrans(result, data: DetailAnnulation) {

        let flexible = {tradcution: null, exeption: null, traductionFee: null};
        switch (result.type) {
            case 0:
                if (data.crFarisType) {
                    flexible.tradcution = {type: result.type, codemot: 'static.afterthe$x1:$x2ofthetotalamountofthefirstnight.', params: {val1: result.to.subtract(1, result.units), val2: data.crFarisPercent + '%'}}
                } else {
                    flexible.tradcution = {type: result.type, codemot: 'static.afterthe$x1:$x2ofthetotalamountofthebooking.', params: {val1: result.to.subtract(1, result.units), val2: data.crFarisPercent + '%'}}
                }
                break;
            case 1:
                if (data.crFarisType) {
                    flexible.tradcution = {type: result.type, codemot: 'static.ifcanceledbetween$x1and$x2:$x3ofthetotalamountofthefirstnight.', params: {val1: result.to, val2: result.from, val3: data.crFarisPercent + '%'}}
                } else {
                    flexible.tradcution = {type: result.type, codemot: 'static.ifcanceledbetween$x1and$x2:$x3ofthetotalamountofthebooking.', params: {val1: result.to, val2: result.from, val3: data.crFarisPercent + '%'}}
                }
                break;
            case 2:
                if (data.crFarisPercent > 0) {
                    if (data.crFarisType) {
                        flexible.tradcution = {type: result.type, codemot: 'static.jusquau$x1$x2dumontanttotaldela1erenuit', params: {val1: result.from.subtract(1, result.units), val2: data.crFarisPercent + '%'}}
                    } else {
                        flexible.tradcution = {type: result.type, codemot: 'static.jusquau$x1$x2dumontanttotaldelareservation', params: {val1: result.from.subtract(1, result.units), val2: data.crFarisPercent + '%'}}
                    }
                }
                else {
                    flexible.tradcution = {type: result.type, codemot: 'static.annulationgratuiteavantle$x1', params: {val1: result.from}}
                }
                break;
            case 3:
                if (data.crFarisPercent > 0) {
                    if (data.crFarisType) {
                        if (result.isHour) {
                            flexible.tradcution = {type: result.type, codemot: 'static.ifcancelledupto$x1hoursbeforearrival$x2ofthefirstnight', params: {val1: (data.to - 1), val2: data.crFarisPercent + '%'}}
                        } else {
                            flexible.tradcution = {type: result.type, codemot: 'static.ifcancelledupto$x1daysbeforearrival$x2ofthefirstnight', params: {val1: (data.to - 1), val2: data.crFarisPercent + '%'}}
                        }
                    } else {
                        if (result.isHour) {
                            flexible.tradcution = {type: result.type, codemot: 'static.ifcancelledupto$x1hoursbeforearrival$x2ofthetotalbookingamount', params: {val1: (data.to - 1), val2: data.crFarisPercent + '%'}}
                        } else {
                            flexible.tradcution = {type: result.type, codemot: 'static.ifcancelledupto$x1daysbeforearrival$x2ofthetotalbookingamount', params: {val1: (data.to - 1), val2: data.crFarisPercent + '%'}}
                        }
                    }
                } else {
                    flexible.tradcution = {type: result.type, codemot: 'static.freecancellationuntil$x1daysbeforearrival', params: {val1: (((data.to - 1) == 0) ? 1 : data.to)}}
                }
                break;
            case 4:
                if (data.crFarisType) {
                    flexible.tradcution = {type: result.type, codemot: 'static.partiallyrefundable$x1firstnight', params: {val1: data.crFarisPercent}}
                } else {
                    flexible.tradcution = {type: result.type, codemot: 'static.partiallyrefundable$x1booking', params: {val1: data.crFarisPercent}}
                }
                break;
            default:
                break;
        }
        if (data.hasMinFee()) {
            let val1 = data.crMinValue.toString(), val2;
            switch (data.crMinType) {
                case BookingPolicyService._CrMinType_Fixe:
                    val2 = this.winRef.appConfigSite.Ccurrency;
                    val1 = (data.crMinValue * this.winRef.appConfigSite.Cpercente).toFixed(2).toString();
                    break;
                case BookingPolicyService._CrMinType_PercenteOfFirstNight:
                    val1 = ''.concat(val1, ' %');
                    this.translate.get('static.1erenuit').subscribe((res: string) => {
                        val2 = res;
                    })
                    break;
                case BookingPolicyService._CrMinType_Nuit:
                    this.translate.get('static.'.concat(data.crMinValue == 1 ? 'nuit' : 'nuits')).subscribe((res: string) => {
                        val2 = res;
                    })
                    break;

                default:

                    break;
            }
            flexible.traductionFee = {codemot: 'static.lesfraisdannulationminimumseleventa$x1$x2', params: {val1: val1, val2: val2}}
        }
        return flexible

    };
}
